export default __webpack_public_path__ + "static/media/CAD.f640c752.svg";